import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import CustomScrollbars from './CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import UserProfile from './UserProfile'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../hooks'
import styled from 'styled-components'
import { mainRoutes } from 'src/screens/routes/metaData'
import Text from 'antd/lib/typography/Text'
import SidebarItem from './SidebarItem'
import SidebarChildItem from './SidebarChildItem'
import Images from 'src/common/Images'
import { useEffect, useState } from 'react'

export const SidebarItemWrapper = styled(Link)`
   .ant-badge-count {
      width: 20px;
      min-width: 20px;
      height: 20px;
      background-color: ${(props) => props.theme.color.red_0};
      .ant-scroll-number-only-unit {
         font-weight: 500;
         font-size: 9px;
         line-height: 20px;
      }
   }
      .nav-item__label{
       width: 220px; !important
      // font-size:12px !important
      }
`

const UserProfileWrapper = styled.div`
   padding: 10px;
   margin: 16px 12px;
   background: #919eab16;
   border-radius: 12px;
`

const SidebarContent = observer((props: any) => {
   const { location } = props
   const AuthStore = useStore('AuthStore')
   const { t } = useTranslation()
   const pathUrl = location.pathname
   const [openKeys, setOpenKeys] = useState<string[]>([])

   useEffect(() => {
      const defaultKeys = getDefaultOpenKeys(props.sideBarContent)
      setOpenKeys(defaultKeys)
   }, [props.sideBarContent])

   const findSelectedKey = (items: any[], path: string): string => {
      for (const item of items) {
         if (item.items) {
            const found = findSelectedKey(item.items, path)
            if (found) return found
         } else if (path.startsWith(item.path)) {
            return item.path
         }
      }
      return ''
   }

   const findParentKey = (items: any[], path: string): string | null => {
      for (const item of items) {
         if (item.items) {
            if (item.items.find((child: any) => child.path === path)) {
               return item.path
            }
            const deeper = findParentKey(item.items, path)
            if (deeper) return deeper
         }
      }
      return null
   }

   const selectedKeys = findSelectedKey(props.sideBarContent, pathUrl)

   const handleCloseSideBar = () => {
      AuthStore.action_closeSidebar()
   }

   const getDefaultOpenKeys = (items: any[]): string[] => {
      let openKeys: string[] = []
      items.forEach((item) => {
         if (item.items) {
            openKeys = openKeys.concat(getDefaultOpenKeys(item.items))
            if (item.items.find((sub: any) => pathUrl === sub.path)) {
               openKeys.push(item.path)
            }
         }
      })
      return openKeys
   }

   const handleOpenChange = (keys: string[]) => {
      setOpenKeys(keys)
   }

   const renderMenus = () => {
      return (
         <>
            {props?.sideBarContent?.map((group: any) => (
               <Menu.ItemGroup
                  key={group?.id}
                  className="gx-menu-group"
                  title={
                     <Text style={{ color: '#000', marginLeft: -12, display: 'flex', fontWeight: '500' }}>
                        {t(group?.labelKey)}
                     </Text>
                  }
               >
                  {group?.items?.map((item: any) =>
                     item.items ? (
                        <Menu.SubMenu
                           key={item?.path}
                           title={
                              <div
                                 style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '4px 16px',
                                    borderRadius: 8,
                                    marginLeft: -20,
                                    background: openKeys.includes(item.path) ? 'transparent' : 'transparent',
                                    color: openKeys.includes(item.path) ? '#ED5C19' : 'inherit',
                                    fontWeight: openKeys.includes(item.path) ? '500' : '400'
                                 }}
                              >
                                 <img src={item?.icon} alt="" style={{ width: 24, height: 24, marginRight: 10 }} />
                                 <div style={{ flex: 1, marginRight: 24 }}>{t(item?.labelKey)}</div>
                                 <img
                                    src={
                                       openKeys.includes(item.path)
                                          ? Images.ic_arrow_right_small_active
                                          : Images.ic_arrow_right_small
                                    }
                                    alt=""
                                    style={{ width: 16, height: 16 }}
                                 />
                              </div>
                           }
                           //@ts-ignore
                           expandIcon={<></>}
                        >
                           {item?.items.map((subItem: any) => (
                              <Menu.Item key={subItem?.path}>
                                 <SidebarItemWrapper
                                    to={subItem?.path}
                                    onClick={() => {
                                       const parentKey = findParentKey(props.sideBarContent, subItem?.path)
                                       if (parentKey) setOpenKeys([parentKey])
                                       // Không đóng sidebar khi click vào item con
                                    }}
                                 >
                                    <SidebarChildItem data={subItem} selectedKeys={selectedKeys} />
                                 </SidebarItemWrapper>
                              </Menu.Item>
                           ))}
                        </Menu.SubMenu>
                     ) : (
                        // Không có item.items
                        <Menu.Item key={item?.path}>
                           <SidebarItemWrapper
                              to={item?.path}
                              onClick={() => {
                                 handleCloseSideBar()
                                 setOpenKeys([])
                              }}
                           >
                              <SidebarItem data={item} selectedKeys={selectedKeys} />
                           </SidebarItemWrapper>
                        </Menu.Item>
                     )
                  )}
               </Menu.ItemGroup>
            ))}
         </>
      )
   }

   return (
      <>
         <SidebarLogo sidebarCollapsed={props.sidebarCollapsed} setSidebarCollapsed={props.setSidebarCollapsed} />
         <div className="gx-sidebar-content">
            <UserProfileWrapper>
               <UserProfile {...props} />
            </UserProfileWrapper>
            <CustomScrollbars className="gx-layout-sider-scrollbar">
               <Menu
                  selectedKeys={[selectedKeys]}
                  theme="light"
                  mode="inline"
                  openKeys={openKeys}
                  //@ts-ignore
                  onOpenChange={handleOpenChange} // ✅ Fix prop name
                  defaultOpenKeys={getDefaultOpenKeys(props.sideBarContent)}
               >
                  {renderMenus()}
               </Menu>
            </CustomScrollbars>
         </div>
      </>
   )
})

export default SidebarContent
